export default "__VITE_ASSET__sNFXBnpU__"